import './content.scss';
import 'select2/dist/js/select2';

export default () => {
	$( document ).ready( function () {
		if ( ( /iPhone|iPad/i ).test( navigator.userAgent ) ) {
			const fakeSelect = $( '.dropdown' );
			const realSelect = $( '.hidden-select' );
			const body = $( 'body' );

			if ( $( window ).width() < 960 ) {
				realSelect.addClass( 'iphone-replacement' );
				fakeSelect.addClass( 'iphone-replacement' );
				body.addClass( 'iphone-replacement-select' );

				fakeSelect.click( function () {
					// eslint-disable-next-line prefer-destructuring
					let element = realSelect[ 0 ];
					let worked = false;

					if ( document.createEvent ) {
						let e = document.createEvent( 'MouseEvents' );

						e.initMouseEvent( 'mousedown', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null );
						worked = element.dispatchEvent( e );
					} else if ( element.fireEvent ) {
						worked = element.fireEvent( 'onmousedown' );
					}
					if ( !worked ) {
						realSelect.removeClass( 'iphone-replacement' );
						body.removeClass( 'iphone-replacement-select' );
					}
				} );
			}
		} else {
			$( 'select' ).select2( {
				DropdownAutoWidth: true,
				Width: 'auto',
			} );
		}

		$( 'select' ).select2( {
			DropdownAutoWidth: true,
			Width: 'auto',
		} );
	} );
};
